export const appConfig = {
    __DEV__: process.env.NODE_ENV === 'development',
    // True on the temporary IP-based deployment (its build sets REACT_APP_SITE_VARIANT=temp).
    // Used to trim main-site-only chrome (top-panel logo/about, footer content).
    isTempSite: process.env.REACT_APP_SITE_VARIANT === 'temp',
    // Base URL used to build shareable links (e.g. /game/<id>). Defaults to whatever
    // origin currently serves the app, so it works on the prod domain, an IP-based
    // temporary VM, or localhost without a rebuild-time change. Overridable at build
    // time with REACT_APP_BASE_URL.
    baseUrl:
        process.env.REACT_APP_BASE_URL ??
        (typeof window !== 'undefined' ? window.location.origin : 'https://client.jamit.io'),
    // Published "Turn-taking" featured template id. The record differs per deployment, so
    // the temp (IP-based) site points at its own copy of the template.
    turntakingTemplateId:
        process.env.REACT_APP_SITE_VARIANT === 'temp'
            ? '6aa7b54c0e6a050edb8379e0'
            : '6aa7b9f3b374905bece47c11',
    // Published "Free play" featured template id, also deployment-specific.
    freeplayTemplateId:
        process.env.REACT_APP_SITE_VARIANT === 'temp'
            ? '6aa7b6b30e6a050edb8379fe'
            : '6aa7ba16b374905bece47c1c',
    // Published "Cover" featured template id (formerly "firsttime"), deployment-specific.
    coverTemplateId:
        process.env.REACT_APP_SITE_VARIANT === 'temp'
            ? '6aace9b0f886b21104f21dba'
            : '6675323ccad6291beae23098',
    // Published "Brainstorm" featured template id, deployment-specific.
    brainstormTemplateId:
        process.env.REACT_APP_SITE_VARIANT === 'temp'
            ? '6aace680cbfb31067b763301'
            : '69c4f22a91f05a489c7e6f9b',
    // Published "Starter" guided template id, deployment-specific.
    starterTemplateId:
        process.env.REACT_APP_SITE_VARIANT === 'temp'
            ? '6ab6334965b5b46c920993ff'
            : '6ab62c0d1591387af6fe6757',
    // Published "Tutorial" guided template id. Same record on both main and temp.
    tutorialTemplateId: '6ab9d6871591387af6fe67c8',
};
